import { configureStore } from "@reduxjs/toolkit";
import { reducer } from "./reducers/reducer";
import { cesiumMiddleware } from "./middlewares/cesium-middleware";
import { initializeCesium, focusOnHome, focusOnSelectedEntity } from "./actions/map";
import { changeVisible, changeOpacity, setSelectedFeature, setZoom, unSelect, setLoading } from "./reducers/map";
import { setTerrain } from "./reducers/terrain";

const cesium = cesiumMiddleware({
    initialize: initializeCesium,
    focusOnHome: focusOnHome,
    setTerrain: setTerrain,
    focusOnSelectedEntity: focusOnSelectedEntity,
    changeVisible: changeVisible,
    changeOpacity: changeOpacity,
    setLoading: setLoading,
    unSelect: unSelect,
    setSelectedFeature: setSelectedFeature, 
    setZoom: setZoom
});
export const store = configureStore({
    reducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false
      }).concat(cesium)
})

